export default "Cool shots from my visit to Monterey, CA for the world-famous car week!";